exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.styles__card-link___3Pf4O{display:flex;text-decoration:none}", ""]);

// exports
exports.locals = {
	"card-link": "styles__card-link___3Pf4O"
};